
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"34","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17 33.667c9.205 0 16.667-7.462 16.667-16.667 0-9.205-7.462-16.667-16.666-16.667C7.796.333.334 7.795.334 17c0 9.205 7.462 16.667 16.667 16.667zm6.18-22.846c.65.651.65 1.707 0 2.357L19.357 17l3.821 3.821a1.667 1.667 0 01-2.357 2.357l-3.821-3.821-3.822 3.821a1.667 1.667 0 01-2.357-2.357L14.644 17l-3.822-3.822a1.667 1.667 0 012.357-2.357l3.822 3.822 3.821-3.822c.651-.65 1.706-.65 2.357 0z","fill":"#313131"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      